import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import {
  Drawer as MUIDrawer,
  DrawerProps as BaseDrawerProps,
} from '@mui/material';

import styles from './Drawer.module.scss';

type DrawerProps = BaseDrawerProps & { onlyContentScroll?: boolean };

export default function Drawer({
  classes,
  onlyContentScroll = true,
  ...rest
}: DrawerProps): JSX.Element {
  return (
    <MUIDrawer
      classes={{
        ...classes,
        paper: classNames(
          styles.paper,
          onlyContentScroll && styles.onlyContentScroll,
          classes?.paper
        ),
      }}
      {...rest}
    />
  );
}

export function DrawerHeader({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={classNames(styles.header, className)} {...props} />;
}

export function DrawerFooter({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div className={classNames(styles.footer, className)} {...props} />;
}
